import { graphitiCollectionResponseToPaginatedData } from "@/nzds/data-grid"
import { httpClient, toHttpError } from "@/utils/api"

import type {
  SiteExplorerPaginatedData,
  SiteExplorerParams,
  SiteExplorerRecord,
  SiteExplorerResourceResponse,
} from "./site-explorer.types"

export const getSiteExplorer = async (
  params: SiteExplorerParams
): Promise<SiteExplorerPaginatedData> => {
  try {
    const response = await httpClient.get<SiteExplorerResourceResponse>(
      "/api/v1/site_explorer",
      {
        params: params.query,
      }
    )
    const { data } = response

    const paginatedData =
      graphitiCollectionResponseToPaginatedData<SiteExplorerRecord>(data)

    const finalResponse: SiteExplorerPaginatedData = {
      ...paginatedData,
      average: data.meta.stats.average?.count ?? null,
      compliant: data.meta.stats.compliant?.count ?? null,
      efficient: data.meta.stats.efficient?.count ?? null,
      inefficient: data.meta.stats.inefficient?.count ?? null,
      non_compliant: data.meta.stats.non_compliant?.count ?? null,
      total_penalties: data.meta.stats.total_penalties?.sum ?? null,
      very_efficient: data.meta.stats.very_efficient?.count ?? null,
      very_inefficient: data.meta.stats.very_inefficient?.count ?? null,
    }

    return finalResponse
  } catch (error: unknown) {
    throw toHttpError(error)
  }
}
